import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.CONFIGURACAO.SET_CASAS_DECIMAIS](state, parametros) {
		state.casasDecimais.quantidade = parametros.casasDecimaisQuantidade
	},
}
